export default () => `<div class="right-section flex flex-col">
<div class="logo flex">
  <img src="https://github.com/ambientstl/cave-game/blob/master/images/map/cave-entrance.png?raw=true" alt="logo" />
</div>

<div class="move-controls flex flex-col">
  <button type="button" class="forward-btn">
    <img src="https://raw.githubusercontent.com/ambientstl/cave-game/master/images/gui/forward.png" alt="forward" />
  </button>
  <button type="button" class="back-btn">
    <img src="https://raw.githubusercontent.com/ambientstl/cave-game/master/images/gui/back.png" alt="back" />
  </button>
</div>
</div>`;
